module.exports = __webpack_public_path__ + "static/media/solutionspage-marketingteams-freelancer-heroimage.6fc295fe.webp";